export const FAILED = "FAILED";
export const FETCHING = "FETCHING";
export const LOG_IN_USER = "LOG_IN_USER";
export const SET_USER_FETCHING_STATUS = "SET_USER_FETCHING_STATUS";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const SUCCESS = "SUCCESS";
